import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LeaguesPage } from './leagues.page';

const routes: Routes = [
    {
        path: ':leagueId',
        loadChildren: () => import('./league-details/league-details.module').then(m => m.LeagueDetailsComponentModule)
    },
    {
        path: '',
        component: LeaguesPage
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class LeaguesPageRoutingModule { }
